import React from 'react';
import { useDrag } from 'react-dnd';
import { Card, colors } from '@dhis2/ui';

const DraggableHigherLevelObjective = ({ objective, isSelected, onSelect }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'higherLevelObjective',
    item: { objective },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  // Map role IDs to display names
  const getRoleDisplayName = (roleId) => {
    const roleNames = {
      'nLSSLch316I': 'CEO',
      'adeqQmxfCLF': 'HOD', 
      'gtMJNK0QVL7': 'TOP STAFF',
      'vdVjNaqxblC': 'SENIOR STAFF'
    };
    return roleNames[roleId] || 'HIGHER LEVEL';
  };

  // Use objective.creatorRole or objective.userRole or objective.objectiveRole
  const roleId = objective.creatorRole || objective.userRole || objective.objectiveRole;
  const roleDisplayName = getRoleDisplayName(roleId);

  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'move',
        marginBottom: '12px',
        height: '100%',
        boxShadow: "0 8px 10px rgba(173, 157, 157, 1)",
      }}
      onClick={() => onSelect(objective)}
    >
      <Card
          style={{
            border: isSelected ? '2px solid #2980b9' : '1px solid #e0e0e0',
            backgroundColor: isSelected ? '#6db8f1ff' : '#5c9d5cff',
            transition: 'all 0.3s ease',
            borderRadius: '12px',
            boxShadow: isDragging
              ? '0 8px 20px rgba(0,0,0,0.2)'
              : '0 2px 8px rgba(0,0,0,0.08)',
            transform: isDragging ? 'scale(1.02)' : 'scale(1)',
          }}  
        >
        <div style={{ 
          padding: '16px', 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column',
          minHeight: '140px',
          
         }}>
          {/* Header with title and role-specific badge */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'flex-start',
            marginBottom: '8px',
            gap: '8px',
         
          }}>
            <h4 style={{ 
              margin: 0, 
              color: '#7f4e1cff',
              fontSize: '0.95rem',
              lineHeight: '1.3',
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              flex: 1,
              minHeight: '2.4rem'
            }}>
              {objective.name}
            </h4>
          </div>
          
          {/* Description */}
          <p style={{ 
            margin: '0 0 12px 0', 
            color: '#7f8c8d', 
            fontSize: '0.85rem',
            lineHeight: '1.4',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            flex: 1,
            minHeight: '2.4rem'
          }}>
            {objective.description || 'No description available'}
          </p>
          
          {/* Bottom section */}
          <div style={{ marginTop: 'auto' }}>
            <div style={{ 
              fontSize: '0.8rem', 
              color: '#95a5a6',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '8px',
              gap: '8px',
              
            }}>
              <span style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flex: 1
              }}>
                {objective.orgUnitName}
              </span>
              <span style={{ 
                padding: '4px 8px',
                backgroundColor: isSelected ? '#4caf50' : '#d0e7edff',
                color: isSelected ? 'white' : '#0a98a2ff',
                borderRadius: '12px',
                fontSize: '0.7rem',
                whiteSpace: 'nowrap',
                flexShrink: 0
              }}>
                Date Created: {objective.startDate ? new Date(objective.startDate).toLocaleDateString() : 'No date'}
              </span>
            </div>
            
            <div style={{ 
              fontSize: '0.7rem', 
              color: '#373a37ff',
              fontStyle: 'italic',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              Created by: {objective.createdBy}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default DraggableHigherLevelObjective;